import React from "react";

const Contact = () => (
  <div className="soon">
    <div className="default-container">
      <div className="def-title">Tuuli légtechnika</div>
      <div>Név: Tanács József</div>
      <div>Telefonszám: +36 30 424 7277</div>
      <div>Email: tanacs.j@gmail.com</div>
      <div>Központ: Kistarcsa</div>
      <div>Részletes ajánlatért kérem keressen e-mail-ben vagy telefonon.</div>
    </div>
  </div>
);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js